var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrammarGame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4296_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4296_28949)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4296_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4296_28949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4613 17.6016C17.3966 17.3769 17.3058 17.1784 17.1889 17.006C17.0719 16.8306 16.9288 16.6829 16.7596 16.5629C16.5934 16.4397 16.4025 16.3459 16.1871 16.2812C15.9748 16.2166 15.7393 16.1843 15.4808 16.1843C14.9976 16.1843 14.5729 16.3043 14.2066 16.5444C13.8435 16.7844 13.5603 17.1338 13.3572 17.5923C13.1541 18.0478 13.0525 18.6049 13.0525 19.2635C13.0525 19.9221 13.1525 20.4822 13.3526 20.9439C13.5526 21.4055 13.8358 21.7579 14.202 22.0011C14.5683 22.2411 15.0007 22.3612 15.4993 22.3612C15.9517 22.3612 16.3379 22.2811 16.658 22.1211C16.9811 21.958 17.2274 21.7287 17.3966 21.4332C17.569 21.1378 17.6552 20.7885 17.6552 20.3853L18.0614 20.4453H15.6239V18.9403H19.5802V20.1314C19.5802 20.9624 19.4048 21.6764 19.0539 22.2734C18.7031 22.8674 18.2199 23.326 17.6044 23.6491C16.9888 23.9692 16.2841 24.1293 15.49 24.1293C14.6037 24.1293 13.825 23.9338 13.1541 23.543C12.4832 23.149 11.96 22.5904 11.5845 21.8672C11.2121 21.1409 11.0259 20.2791 11.0259 19.282C11.0259 18.5156 11.1367 17.8324 11.3583 17.2322C11.5829 16.629 11.8969 16.1181 12.3 15.6996C12.7032 15.281 13.1726 14.9625 13.7081 14.744C14.2436 14.5254 14.8237 14.4162 15.4485 14.4162C15.984 14.4162 16.4826 14.4947 16.9442 14.6516C17.4059 14.8055 17.8152 15.024 18.1722 15.3072C18.5323 15.5903 18.8262 15.9273 19.0539 16.3182C19.2817 16.706 19.4279 17.1338 19.4925 17.6016H17.4613ZM26.8309 17.6016C26.7663 17.3769 26.6755 17.1784 26.5585 17.006C26.4416 16.8306 26.2985 16.6829 26.1292 16.5629C25.963 16.4397 25.7722 16.3459 25.5568 16.2812C25.3444 16.2166 25.109 16.1843 24.8504 16.1843C24.3672 16.1843 23.9425 16.3043 23.5763 16.5444C23.2131 16.7844 22.93 17.1338 22.7269 17.5923C22.5237 18.0478 22.4222 18.6049 22.4222 19.2635C22.4222 19.9221 22.5222 20.4822 22.7222 20.9439C22.9223 21.4055 23.2054 21.7579 23.5717 22.0011C23.9379 22.2411 24.3703 22.3612 24.8689 22.3612C25.3213 22.3612 25.7076 22.2811 26.0276 22.1211C26.3508 21.958 26.597 21.7287 26.7663 21.4332C26.9386 21.1378 27.0248 20.7885 27.0248 20.3853L27.4311 20.4453H24.9936V18.9403H28.9499V20.1314C28.9499 20.9624 28.7744 21.6764 28.4236 22.2734C28.0727 22.8674 27.5896 23.326 26.974 23.6491C26.3585 23.9692 25.6537 24.1293 24.8597 24.1293C23.9733 24.1293 23.1947 23.9338 22.5237 23.543C21.8528 23.149 21.3296 22.5904 20.9541 21.8672C20.5817 21.1409 20.3955 20.2791 20.3955 19.282C20.3955 18.5156 20.5063 17.8324 20.7279 17.2322C20.9526 16.629 21.2665 16.1181 21.6697 15.6996C22.0729 15.281 22.5422 14.9625 23.0777 14.744C23.6132 14.5254 24.1934 14.4162 24.8181 14.4162C25.3536 14.4162 25.8522 14.4947 26.3139 14.6516C26.7755 14.8055 27.1848 15.024 27.5418 15.3072C27.9019 15.5903 28.1958 15.9273 28.4236 16.3182C28.6513 16.706 28.7975 17.1338 28.8622 17.6016H26.8309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4296_28949",
    x: 1.33398,
    y: 1,
    width: 37.334,
    height: 37.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4296_28949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4296_28949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4296_28949",
    x: 1.33398,
    y: 1,
    width: 37.334,
    height: 37.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4296_28949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4296_28949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4296_28949",
    x: 8.59173,
    y: 14.416,
    width: 22.7912,
    height: 14.5802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4296_28949"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4296_28949",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4296_28949",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#830FB3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammarGame);
export default __webpack_public_path__ + "static/media/GrammarGame.6eddc1e96d90ce784c12afd983633af6.svg";
export { ForwardRef as ReactComponent };